module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_65.5af46d6e.jpg";